import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import { Field, useField } from 'react-final-form';
import ReactSelect from 'react-select';
import CalendarFormPopup from 'components/Form/FinalForm/CalendarFormPopup';
import { useState } from 'react';
import CalendarIcon from 'components/Icons/calendar.svg';
import moment from 'moment';
import { formatYearAndMonth } from 'utils/dates';

const DisplayWrapper = styled.div<{ isSelected: boolean }>`
  background: #66666699;
  border: 1px solid #ffffff66;

  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 8px;
  gap: 4px;
  min-width: 94px;
  border-radius: 30px;
`;

const DisplayText = styled.span`
  color: #ffffff;
  font-size: 12px;
  line-height: 16px;
  min-width: fit-content;
  font-weight: 500;
`;

export const CameraPlateDatePicker = () => {
  const { level1SectionId, imageIndex } = useCameraViewContext();

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const openPopover = (e: any) => setAnchorEl(e.target);
  const closePopover = () => setAnchorEl(null);

  return (
    <Field name={`${level1SectionId}.images.${imageIndex}.expiration_date`}>
      {props => (
        <>
          <DisplayWrapper onClick={openPopover}>
            <CalendarIcon />
            <DisplayText>{formatYearAndMonth(props.input.value)}</DisplayText>
          </DisplayWrapper>
          <CalendarFormPopup {...props} close={closePopover} anchorEl={anchorEl} />
        </>
      )}
    </Field>
  );
};
